import React from 'react';

import { EmptyContainer } from './styles';
import { Button } from '../../Button/Button';
import { Icon } from '../../Icon/Icon';
import { Text } from '../../Text/Text';
import { Row } from '../Row';

interface EmptyPageProps {
    iconName?: string;
    emptyText?: React.ReactNode;
    emptyButtonCaption?: string;
    emptyButtonClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const EmptyPage: React.FC<EmptyPageProps> = ({ iconName, emptyText, emptyButtonCaption, emptyButtonClick }) => {
    return (
        <EmptyContainer>
            {iconName && (
                <Row indent="16px">
                    <Icon name={iconName} color="secondary" />
                </Row>
            )}
            <Text color="secondary" indent={emptyButtonCaption ? 'adaptive-16-24' : undefined}>
                {emptyText}
            </Text>
            {emptyButtonCaption && <Button variant="row" caption={emptyButtonCaption} onClick={emptyButtonClick} negativeMargin />}
        </EmptyContainer>
    );
};
